import { render, staticRenderFns } from "./brain13.vue?vue&type=template&id=50803825&scoped=true"
import script from "./brain13.vue?vue&type=script&lang=js"
export * from "./brain13.vue?vue&type=script&lang=js"
import style0 from "./brain13.vue?vue&type=style&index=0&id=50803825&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50803825",
  null
  
)

export default component.exports